import styled from 'styled-components';

export const LoaderContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  p {
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 1.7rem;
    margin-top: 26%;
  }
`;

export const LoaderImg = styled.img`
  width: 250px;
  top: 42%;
  left: 44%;
  z-index: 9999;
  position: absolute;
`;
